import { Distance } from '../../../../../FrontendBundle/Resources/js/ofcs';
import MoveItemsCommand from '../command/moveItemsCommand';
import DrillItem from '../item/drillItem';
import LeftField from './leftField';

/**
 * @class CenterLeftField
 */
export default class CenterLeftField extends LeftField {
    type = 'centerLeft';
    supports = 'supportsPositioning';

    /**
     * Update item with field value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.setValue(item.get('position').x);
    }

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const value = this.getValue();
        const difference = value - item.get('position').x;
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        this.assertItemValue(item, 'left', value);

        if (difference) {
            const command = new MoveItemsCommand(
                item,
                new Distance(difference, 0),
            );

            this.commandExecutor.execute(command);
            this.setValue(item.get('position').x);
            history.addCommand(command);
        }
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     *
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();
        const command = new MoveItemsCommand(
            item,
            new Distance(difference, 0),
        );

        this.assertItemValue(item, 'left', item.get('position').x + difference);

        this.commandExecutor.execute(command);
        this.setValue(item.get('position').x);
        history.addCommand(command);
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1
            && item
            && item instanceof DrillItem;
    }
}
